<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              ref="menu"
              v-model="fromTime"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="queryParams.fromTime"
                  label="From Time"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="fromTime"
                format="24hr"
                v-model="queryParams.fromTime"
                full-width
                @click:minute="$refs.menu.save(queryParams.fromTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              ref="menu1"
              v-model="toTime"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="queryParams.toTime"
                  label="To Time"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="toTime"
                format="24hr"
                v-model="queryParams.toTime"
                full-width
                @click:minute="$refs.menu1.save(queryParams.toTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-text-field name="saleNo" label="Sale No" v-model="queryParams.saleNo" type="text"></v-text-field>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
            <v-select
              :items="shopList"
              label="Choose Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.shopId"
              @change="getCountersByShopId(queryParams.shopId)"
            ></v-select>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-select
              :items="counterList"
              label="Counter Name"
              item-text="name"
              item-value="id"
              v-model="queryParams.counterId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="payTypes"
              label="PayType"
              item-text="label"
              item-value="value"
              v-model="queryParams.payType"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="cashierList"
              label="Cashier"
              item-text="username"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.cashierId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="salePersonList"
              label="Sale Person"
              item-text="username"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.salePersonId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
                <v-autocomplete
                  v-model="queryParams.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Tax:</span>
              <v-chip>
                <span>{{ totalTaxAmount | decFormat}}</span>
              </v-chip>
              <v-btn
                color="primary"
                :loading="buttonLoading"
                @click="reprintSaleDetail('printDetail')"
              >PRINT DETAIL</v-btn>
              <v-btn
                color="primary"
                :loading="buttonLoading"
                @click="reprintSaleSummary('printSaleSummary')"
              >PRINT SUMMARY</v-btn>
              <v-btn
                :loading="buttonLoading"
                color="success"
                @click="exportAllSaleReport()"
              >EXPORT ALL</v-btn>
            </div>
            <div>
              <span>Total Sale Amount:</span>
              <v-chip>
                <span>{{ totalAmount | decFormat}}</span>
              </v-chip>

              <span>Total Return Amount:</span>
              <v-chip>
                <span>{{ totalReturnAmount | decFormat}}</span>
              </v-chip>

              <span>Total Discount Amount:</span>
              <v-chip>
                <span>{{ totalDiscountAmount | decFormat}}</span>
              </v-chip>

              <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalNetAmount | decFormat}}</span>
              </v-chip>
            </div>
            <div>
              <span @click="getCreditList()">Total Credit Amount:</span>
              <v-chip>
                <span @click="getCreditList()">{{ creditPaidAmount | decFormat}}</span>
              </v-chip>
            </div>
          </v-card-text>
          <v-data-table
            :must-sort="true"
            :headers="summaryHeaders"
            :items="saleSummaryList"
            :rows-per-page-items="rowsPerPageItems2"
            :pagination.sync="pagination2"
            expand
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.caisherName }}</td>
              <td>{{ props.item.counterName }}</td>
              <td>{{ props.item.payType }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.amount | decFormat}}</td>
              <td>{{ props.item.taxAmount | decFormat}}</td>
              <td>{{ props.item.discountAmount | decFormat}}</td>
              <td>{{ props.item.netAmount | decFormat}}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.saleNo }}</td>
                <td>{{ props.item.shopName }}</td>
                <td>{{ props.item.counterName }}</td>
                <td>{{ props.item.createdBy }}</td>
                <td>{{ props.item.salePerson }}</td>
                <td>{{ props.item.payType}}</td>
                <td v-if="props.item.customer">{{ props.item.customer.creditLevel.periodDays }}</td>
                <td v-else>-</td>
                <td>{{ props.item.currencyCode }}</td>
                <td>{{ props.item.totalAmount | decFormat }}</td>
                <td>{{ props.item.taxAmount | decFormat }}</td>
                <td>{{ props.item.discountAmount | decFormat}}</td>
                <td>{{ props.item.netAmount | decFormat}}</td>
                <td>{{ props.item.receivedAmount | decFormat }}</td>
                <td>{{ props.item.payChange | decFormat }}</td>
                <td>{{ props.item.totalReturnAmount | decFormat }}</td>
                <td>{{ props.item.creditPaidAmount | decFormat }}</td>
                <td>{{ props.item.remark }}</td>
                <td>
                  <v-btn color="primary" @click.stop="reprint(props.item)">REPRINT</v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.saleItems"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.product.name }}</td>
                      <td class="text-xs">{{ subprops.item.product.color }}</td>
                      <td class="text-xs">
                        <v-icon
                          center
                          color="success"
                          v-if="subprops.item.isFOC == true"
                        >check_circle</v-icon>
                      </td>
                      <td class="text-xs">
                        <v-icon
                          center
                          color="success"
                          v-if="subprops.item.isReturn == true"
                        >check_circle</v-icon>
                      </td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.productUnit.factor+"/"+subprops.item.productUnit.unitName}}</td>
                      <td class="text-xs">{{ subprops.item.unitPrice | decFormat }}</td>
                      <td class="text-xs">{{ subprops.item.qty }}</td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.unitPrice * subprops.item.qty | decFormat }}</td>
                      <td class="text-xs">{{ subprops.item.returnQty }}</td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.unitPrice * subprops.item.returnQty | decFormat }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
        <!-- </v-expansion-panel> -->
      </v-flex>
    </v-layout>
    <!-- reprint sale slip hidden area -->
    <div
      v-show="false"
      v-for="(sale,index) in saleReportList"
      :key="index"
      :id="`printSaleDetail${sale.id}`"
      :data="sale"
    >
      <div style="font-size: 11px;font-family: arial,sans-serif;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shop.address}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{sale.shop.phoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p
            style="font-size:11px;margin:0px"
            id="date"
          >{{ sale.createdDateInMilliSeconds | format-ms-custom-date }}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;font-weight:bold;margin:0px">REPRINT</p>
        </div>
        <div style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counterName}}</p>
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.createdBy}}</p>
          <p style="font-size:11px;margin:0px" id="casher">Sale: {{sale.salePerson}}</p>
          <p style="font-size:11px;margin:0px" id="customer">Customer: <span v-if="sale.customer">{{sale.customer.name}}</span></p>
        </div>
       <div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Currency: {{sale.currencyCode}}</p>
          <p style="font-size:11px;margin:0px" id="casher"></p>
        </div>
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%"></th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.notFocItems" :key="index">
                <td
                  style="text-align:left;width:50%"
                >{{item.product.name}} {{'(' + item.product.color + ')'}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | decFormat}}</td>
                <td style="text-align:right;width:20%">{{item.qty * item.unitPrice| decFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
          >
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.totalAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.taxAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
                v-if="sale.discountAmount > 0"
              >{{sale.discountAmount | decFormat}}</td>
              <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.receivedAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.payChange | decFormat}}</td>
            </tr>
          </table>
        </div>
        <!-- FOC Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.focItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">FOC Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.focItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Return Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.returnItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">Return Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.returnItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.returnQty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | decFormat}}</td>
                <td
                  style="text-align:right;width:20%"
                >{{item.returnQty * item.unitPrice | decFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
        </div>
        <div style="height:5px;"></div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
        </div>
      </div>
    </div>
    <!-- <detail report> -->
    <div id="printDetail" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Sale Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <!--<div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Tax: {{totalTaxAmount | numFormat}}</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Amount: {{totalAmount | numFormat}}</p>
      </div>-->
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <!--<table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Shop Name</th>
              <th style="text-align:left">Counter Name</th>
              <th style="text-align:left">Pay Type</th>
              <th style="text-align:left">Total Amount</th>
              <th style="text-align:left">Total Tax Amount</th>
              <th style="text-align:left">Discount Amount</th>
              <th style="text-align:left">Return Amount</th>
              <th style="text-align:left">Total Net Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in saleSummaryReportList" :key="index">
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.counterName}}</td>
              <td style="text-align:left">{{item.payType}}</td>
              <td style="text-align:left">{{item.amount | numFormat}}</td>
              <td style="text-align:left">{{item.taxAmount | numFormat}}</td>
              <td style="text-align:left">{{item.discountAmount | numFormat}}</td>
              <td style="text-align:left">{{item.returnAmount | numFormat}}</td>
              <td style="text-align:left"
              >{{item.amount-item.discountAmount-item.returnAmount | numFormat}}</td>
              </tr>
          </tbody>
        </table>-->
        <div style="height:10px"></div>
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Sale Date</th>
              <th style="text-align:left">Sale No</th>
              <th style="text-align:left">Shop Name</th>
              <th style="text-align:left">Counter Name</th>
              <th style="text-align:left">Casiher Name</th>
              <th style="text-align:left">Sale Person</th>
              <th style="text-align:left">Currency</th>
              <th style="text-align:left">Total Amount</th>
              <th style="text-align:left">Tax Amount</th>
              <th style="text-align:left">Discount Amount</th>
              <th style="text-align:left">Net Amount</th>
              <th style="text-align:left">Credit Amount</th>
              <th style="text-align:left">Received</th>
              <th style="text-align:left">Pay Change</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allSaleReportList" :key="index">
              <td style="text-align:left">{{item.createdDateInMilliSeconds | format-ms-date}}</td>
              <td style="text-align:left">{{item.saleNo}}</td>
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.counterName}}</td>
              <td style="text-align:left">{{item.createdBy}}</td>
              <td style="text-align:left">{{item.salePerson}}</td>
              <td style="text-align:left">{{item.currencyCode}}</td>
              <td style="text-align:left">{{item.totalAmount | decFormat}}</td>
              <td style="text-align:left">{{item.taxAmount | decFormat}}</td>
              <td style="text-align:left">{{item.discountAmount | decFormat}}</td>
              <td style="text-align:left">{{item.netAmount | decFormat}}</td>
              <td style="text-align:left">{{item.creditPaidAmount | decFormat}}</td>
              <td style="text-align:left">{{item.receivedAmount | decFormat}}</td>
              <td style="text-align:left">{{item.payChange | decFormat}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--summary report-->
    <div id="printSaleSummary" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Sale Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Cash Sale</p>
      </div>
      <!--Cash sale table-->
      <table
        style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
      >
        <thead style="border-bottom:1px solid black;border-top:1px solid black">
          <tr>
            <th style="text-align:left">Shop</th>
            <th style="text-align:left">Cashier</th>
            <th style="text-align:left">Counter</th>
            <th style="text-align:left">Customer</th>
            <th style="text-align:left">Currency</th>
            <th style="text-align:left">Amount</th>
            <th style="text-align:left">Tax</th>
            <th style="text-align:left">Discount</th>
            <th style="text-align:left">Net Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in cashSaleList"
            :key="index"
            style="border-bottom:1px solid black;border-top:1px solid black"
          >
            <td style="text-align:left">{{item.shopName}}</td>
            <td style="text-align:left">{{item.caisherName}}</td>
            <td style="text-align:left">{{item.counterName}}</td>
            <td style="text-align:left">{{item.customerName}}</td>
            <td style="text-align:left">{{item.currencyCode}}</td>
            <td style="text-align:left">{{item.amount | decFormat}}</td>
            <td style="text-align:left">{{item.taxAmount | decFormat}}</td>
            <td style="text-align:left">{{item.discountAmount | decFormat}}</td>
            <td
              style="text-align:left"
            >{{item.netAmount | decFormat}}</td>
          </tr>
          <tr style="border-bottom:1px solid black;border-top:1px solid black;font-weight: 900">
            <td style="text-align:left"></td>
            <td style="text-align:left"></td>
            <td style="text-align:left"></td>
            <td style="text-align:left"></td>
            <td style="text-align:center">Total</td>
            <td style="text-align:left">{{totalCashSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totaltaxCashSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totaldiscountCashSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totalNetCashSaleAmount | decFormat}}</td>
          </tr>
        </tbody>
      </table>
      <!--end cash sale table-->
      <div style="height:10px"></div>
      <div style="height:10px"></div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Credit Sale</p>
      </div>
      <!--credit sale-->
      <table
        style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
      >
        <thead style="border-bottom:1px solid black;border-top:1px solid black">
          <tr>
            <th style="text-align:left">Shop</th>
            <th style="text-align:left">Cashier</th>
            <th style="text-align:left">Counter</th>
            <th style="text-align:left">Customer</th>
            <th style="text-align:left">Currency</th>
            <th style="text-align:left">Amount</th>
            <th style="text-align:left">Tax</th>
            <th style="text-align:left">Discount</th>
            <th style="text-align:left">Net Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in creditSaleList"
            :key="index"
            style="border-bottom:1px solid black;border-top:1px solid black"
          >
            <td style="text-align:left">{{item.shopName}}</td>
            <td style="text-align:left">{{item.caisherName}}</td>
            <td style="text-align:left">{{item.counterName}}</td>
            <td style="text-align:left">{{item.customerName}}</td>
            <td style="text-align:left">{{item.currencyCode}}</td>
            <td style="text-align:left">{{item.amount | decFormat}}</td>
            <td style="text-align:left">{{item.taxAmount | decFormat}}</td>
            <td style="text-align:left">{{item.discountAmount | decFormat}}</td>
            <td
              style="text-align:left"
            >{{item.netAmount | decFormat}}</td>
          </tr>
          <tr style="border-bottom:1px solid black;border-top:1px solid black;font-weight: 900">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td style="text-align:center">Total</td>
            <td style="text-align:left">{{totalCreditSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totaltaxCreditSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totaldiscountCreditSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totalNetCreditSaleAmount | decFormat}}</td>
          </tr>
        </tbody>
      </table>
      <!--end credit sale-->
      <div style="height:10px"></div>
      <div style="height:10px"></div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Whole Sale</p>
      </div>
      <!--whole sale-->
      <table
        style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
      >
        <thead style="border-bottom:1px solid black;border-top:1px solid black">
          <tr>
            <th style="text-align:left">Shop</th>
            <th style="text-align:left">Cashier</th>
            <th style="text-align:left">Customer</th>
            <th style="text-align:left">Currency</th>
            <th style="text-align:left">Amount</th>
            <th style="text-align:left">Tax</th>
            <th style="text-align:left">Discount</th>
            <th style="text-align:left">Net Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in wholeSaleList"
            :key="index"
            style="border-bottom:1px solid black;border-top:1px solid black"
          >
            <td style="text-align:left">{{item.shopName}}</td>
            <td style="text-align:left">{{item.createdBy}}</td>
            <td style="text-align:left">{{item.customerName}}</td>
            <td style="text-align:left">{{ item.currencyCode }}</td>
            <td style="text-align:left">{{item.totalAmount | decFormat}}</td>
            <td style="text-align:left">{{item.taxAmount | decFormat}}</td>
            <td style="text-align:left">{{item.discountAmount | decFormat}}</td>
            <td
              style="text-align:left"
            >{{item.netAmount | decFormat}}</td>
          </tr>
          <tr style="border-bottom:1px solid black;border-top:1px solid black;font-weight: 900">
            <td></td>
            <td></td>
            <td></td>
            <td style="text-align:center">Total</td>
            <td style="text-align:left">{{totalWholeSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totaltaxWholeSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totaldiscountWholeSaleAmount | decFormat}}</td>
            <td style="text-align:left">{{totalNetWholeSaleAmount | decFormat}}</td>
          </tr>
        </tbody>
      </table>
      <!--end whole sale-->
      <div style="height:10px"></div>
      <div style="height:10px"></div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Credit Receipt</p>
      </div>
      <!--credit receipt-->
      <table
        style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
      >
        <thead style="border-bottom:1px solid black;border-top:1px solid black">
          <tr>
            <th style="text-align:left">Shop</th>
            <th style="text-align:left">Customer</th>
            <th style="text-align:left">Currency</th>
            <th style="text-align:left">Net Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in creditReceiptList"
            :key="index"
            style="border-bottom:1px solid black;border-top:1px solid black"
          >
            <td style="text-align:left">{{item.shopName}}</td>
            <td style="text-align:left">{{item.customerName}}</td>
            <td style="text-align:left">{{ item.currencyCode }}</td>
            <td style="text-align:left">{{item.netAmount | decFormat}}</td>
          </tr>
          <tr style="border-bottom:1px solid black;border-top:1px solid black;font-weight: 900">
            <td></td>
            <td></td>
            <td style="text-align:center">Total</td>
            <td style="text-align:left">{{totalCreditReceiptNetAmount | decFormat}}</td>
          </tr>
        </tbody>
      </table>
      <!--end credit receipt-->
    </div>
    <!-- credit List  -->
    <v-dialog v-model="showCreditListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="headline white--text">Customer Credit List</span>
        </v-card-title>
        <v-card-text>
          <div class="font-weight-bold">
            <span>Total Credit Amount:</span>
            <v-chip>
              <span>{{ creditPaidAmount | decFormat}}</span>
            </v-chip>
          </div>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="creditListHeader"
                :items="creditList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalCreditRows"
                :rows-per-page-items="rowsPerPageItemsCredit"
                :pagination.sync="paginationCredit"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.customerCode }}</td>
                  <td>{{ props.item.customerName }}</td>
                  <td>{{ props.item.invoiceNo }}</td>
                  <td>{{ props.item.creditPaidAmount | decFormat }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { saleReportService } from "../../services/sale-report-service";
import { shopService } from "../../services/shop-service";
import { Sale } from "../../models/model";
import { counterService } from "../../services/counter-service";
import { saleService } from "../../services/sale-service";
import { userService } from "../../services/user-service";
import { currencyService } from "../../services/currency-service";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "SaleReportList",

  components: { Loading },
  data: () => ({
    time: false,
    fromTime: false,
    toTime: false,
    showListLoading: false,
    messageDialogBox: false,
    dialog: false,
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Sale Date ", align: "left", value: "created_date" },
      { text: "Sale No", value: "sale_no" },
      { text: "Shop Name", value: "sh.name" },
      { text: "Counter", value: "c.name" },
      { text: "Casher Name", value: "created_by" },
      { text: "Sale Person", value: "sale_person" },
      { text: "Pay Type", value: "pay_type" },
      {
        text: "Period Days",
        align: "center",
        value: "period_days",
        sortable: false,
      },
      { text: "Currency", value: "currencyCode" },
      { text: "Total Amount", value: "total_amount" },
      { text: "Tax", value: "tax_amount" },
      { text: "Discount", value: "discount_amount" },
      { text: "Net Amount", value: "net_amount" },
      { text: "Received", sortable: false },
      { text: "Pay Change", value: "pay_change" },
      { text: "Total Return Amount", value: "total_return_amount" },
      { text: "Credit Amount", value: "total_credit_amount" },
      { text: "Remark", value: "remark" },
      { text: "Reprint", align: "center", sortable: false },
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "Product Color", sortable: false },
      { text: "FOC", sortable: false },
      { text: "Return", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Qty", sortable: false },
      { text: "Total Amount", sortable: false },
      { text: "Return Qty", sortable: false },
      { text: "Total Return Amount", sortable: false },
    ],
    creditListHeader: [
      { text: "Customer Code", sortable: false },
      { text: "Customer Name", sortable: false },
      { text: "Sale No", sortable: false },
      { text: "Credit Amount", sortable: false },
    ],
    summaryHeaders: [
      { text: "Shop Name", align: "left", value: "shopName", sortable: false },
      {
        text: "Cashier Name",
        align: "left",
        value: "cashierName",
        sortable: false,
      },
      { text: "Counter Name", value: "counterName", sortable: false },
      { text: "Cash Type", align: "left", value: "cashType", sortable: false },
      { text: "Currency", value: "currencyCode", sortable: false },
      { text: "Total Amount", value: "totalAmount", sortable: false },
      { text: "Total Tax Amount", value: "totalTaxAmount", sortable: false },
      {
        text: "Total Discount Amount",
        value: "totalDiscountAmount",
        sortable: false,
      },
      { text: "Total Net Amount", value: "totalNetAmount", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    rowsPerPageItemsCredit: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "created_date",
      totalItems: 0,
    },
    paginationCredit: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "created_date",
      totalItems: 0,
    },
    rowsPerPageItems2: [25, 50, 100],
    pagination2: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0,
    },
    showCreditListDialog: false,
    shopList: [],
    counterList: [],
    saleReportList: [],
    creditList: [],
    allSaleReportList: [],
    saleSummaryReportList: [],
    saleSummaryList: [],
    saleDetailList: [],
    cashierList: [],
    salePersonList: [],
    cashSaleList: [],
    creditSaleList: [],
    creditReceiptList: [],
    wholeSaleList: [],
    sale: new Sale(),
    totalAmount: 0,
    totalNetAmount: 0,
    totalDiscountAmount: 0,
    totalTaxAmount: 0,
    totalReturnAmount: 0,
    creditPaidAmount: 0,
    saleNo: 0,
    totalRows: 0,
    totalCreditRows: 0,
    totalCashSaleAmount: 0,
    totalCreditSaleAmount: 0,
    totaltaxCashSaleAmount: 0,
    totaltaxCreditSaleAmount: 0,
    totaldiscountCashSaleAmount: 0,
    totaldiscountCreditSaleAmount: 0,
    totalNetCashSaleAmount: 0,
    totalNetCreditSaleAmount: 0,
    totalWholeSaleAmount: 0,
    totaltaxWholeSaleAmount: 0,
    totaldiscountWholeSaleAmount: 0,
    totalNetWholeSaleAmount: 0,
    totalCreditReceiptNetAmount: 0,
    responseError: "",
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      fromTime: "00:00",
      toTime: "23:59",
      saleNo: "",
      counterId: "",
      shopId: "",
      userName: "",
      payType: "",
      cashierId: "",
      salePersonId: "",
      currencyId: ""
    },
    currencyList: [],
    clonequeryParams: new Object(),
    buttonLoading: false,
    isLoading: false,
    payTypes: [
      { label: "----All----", value: "" },
      { label: "CASH", value: "CASH" },
      { label: "CREDIT", value: "CREDIT" },
    ],
    fullPage: true,
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleSummaryList();
        this.getSaleReportList();
      },
      deep: true,
    },
    paginationCredit: {
      handler() {
        this.getCreditList();
      },
      deep: true,
    },
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "ADMIN" || user.role.roleName == "BRANCH_ADMIN"){
      this.getAllShop();
    }
    if (user.role.roleName != "ADMIN" || user.role.roleName != "BRANCH_ADMIN") {
      this.queryParams.shopId = user.shopId;
    }
    if (user.shopId) {
      this.getCountersByShopId(user.shopId);
    }
    if (user.role.roleName == "SALE") {
      this.queryParams.userName = user.username;
    }
    //for deep linking
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.counterId) {
      this.queryParams.counterId = this.$route.query.counterId;
    }
    if (this.$route.query.saleNo) {
      this.queryParams.saleNo = this.$route.query.saleNo;
    }
    if (this.$route.query.userName) {
      this.queryParams.userName = this.$route.query.userName;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.fromTime) {
      this.queryParams.fromTime = this.$route.query.fromTime;
    }
    if (this.$route.query.toTime) {
      this.queryParams.toTime = this.$route.query.toTime;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllCashier();
    this.getAllSalePerson();
    this.getActiveCurrency()
    .finally(() => {
        this.onSearch();
    });
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "sale-report", query: this.queryParams });
      this.getSaleSummaryList();
      this.getSaleReportList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    getSaleReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleReportService
        .getSaleReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.saleReportList = res.data.saleList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getSaleSummaryList() {
      saleReportService
        .getSaleSummaryList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.saleSummaryList = res.data.saleSummaryList;
            this.totalAmount = res.data.totalAmount;
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalDiscountAmount = res.data.totalDiscountAmount;
            this.totalTaxAmount = res.data.totalTaxAmount;
            this.totalReturnAmount = res.data.totalReturnAmount;
            this.creditPaidAmount = res.data.creditPaidAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {});
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getCreditList() {
      if (this.creditPaidAmount > 0) {
        this.showCreditListDialog = true;
      } else {
        this.showCreditListDialog = false;
      }
      let order = this.paginationCredit.descending ? "desc" : "asc";
      saleReportService
        .getCreditList(
          this.clonequeryParams,
          this.paginationCredit.page,
          this.paginationCredit.rowsPerPage,
          this.paginationCredit.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.creditList = res.data.customerCreditBalanceList;
            this.totalCreditRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllCashier() {
      userService
        .getAllCaisher()
        .then((res) => {
          this.cashierList = res.data;
          let findAll = {
            id: "",
            username: "---All---",
          };
          this.cashierList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    getAllSalePerson() {
      userService
        .getAllSalePerson()
        .then((res) => {
          this.salePersonList = res.data;
          let findAll = {
            id: "",
            username: "---All---",
          };
          this.salePersonList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    getCountersByShopId(shopId) {
      this.counterList = [];
      this.queryParams.counterId = "";
      if (shopId) {
        counterService
        .getCountersByShopId(shopId)
        .then((res) => {
          this.counterList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.counterList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
      }
    },

    reprint(sale) {
      this.isLoading = true;
      if (sale.payType == "CREDIT") {
        this.printInvoiceById(sale.id);
      } else {
        this.reprintSaleDetail("printSaleDetail" + sale.id);
        this.isLoading = false;
      }
    },

    printInvoiceById(id) {
      saleService
        .printSaleInvoiceById(id)
        .then((res) => {
          var blob = res;
          saleService.showWindowDialog(blob, "SaleInvoice-" + id);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    reprintSaleDetail(divName) {
      let diffTime = Math.abs(
        new Date(this.clonequeryParams.toDate) -
          new Date(this.clonequeryParams.fromDate)
      );
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 8) {
        this.buttonLoading = true;

        saleReportService
          .getAllSaleReportList(this.clonequeryParams)
          .then((res) => {
            if (res.data) {
              this.allSaleReportList = res.data.saleList;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            saleReportService
              .getSaleSummaryList(this.clonequeryParams)
              .then((res) => {
                if (res.data) {
                  this.saleSummaryReportList = res.data.saleSummaryList;
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                var printContents = document.getElementById(divName).innerHTML;
                var reprintWindow = window.open(
                  "",
                  "MsgWindow",
                  "width=500,height=500"
                );
                reprintWindow.document.write(printContents);
                setTimeout(() => {
                  reprintWindow.print();
                  reprintWindow.close();
                }, 600);
                this.buttonLoading = false;
              });
          });
      } else {
        this.messageDialogBox = true;
        this.responseError = "Choose a date range filter within a week!";
      }
    },
    clear() {
      this.queryParams.data = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.queryParams.fromTime = "00:00";
      this.queryParams.toTime = "23:59";
    },
    exportAllSaleReport() {
      let diffTime = Math.abs(
        new Date(this.clonequeryParams.toDate) -
          new Date(this.clonequeryParams.fromDate)
      );
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 8) {
        this.buttonLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";

        saleReportService
          .exportSaleReportExcel(
            this.queryParams,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            commonService.downloadE(res);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.buttonLoading = false;
          });
      } else {
        this.messageDialogBox = true;
        this.responseError = "Choose a date range filter within a week!";
      }
    },
    getActiveCurrency(){
    return currencyService.getCurrencyByStatus('ACTIVE')
    .then(res => {
      if(res.data){
        this.currencyList = res.data;
        let c = commonService.search("defaultCurrency",true,this.currencyList);
        if(c){
          this.queryParams.currencyId = c.id;
        }
      }
    })
    .catch((err) => {
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    reprintSaleSummary(divName) {
      this.cashSaleList = [];
      this.totalCashSaleAmount = 0;
      this.totaltaxCashSaleAmount = 0;
      this.totaldiscountCashSaleAmount = 0;
      this.totalNetCashSaleAmount = 0;

      this.creditSaleList = [];
      this.totalCreditSaleAmount = 0;
      this.totaltaxCreditSaleAmount = 0;
      this.totaldiscountCreditSaleAmount = 0;
      this.totalNetCreditSaleAmount = 0;

      this.wholeSaleList = [];
      this.totalWholeSaleAmount = 0;
      this.totaltaxWholeSaleAmount = 0;
      this.totaldiscountWholeSaleAmount = 0;
      this.totalNetWholeSaleAmount = 0;

      this.creditReceiptList=[];
      this.totalCreditReceiptNetAmount=0;

      let diffTime = Math.abs(
        new Date(this.clonequeryParams.toDate) -
          new Date(this.clonequeryParams.fromDate)
      );
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 8) {
        this.buttonLoading = true;

        saleReportService
          .getAllSaleReportList(this.clonequeryParams)
          .then((res) => {
            if (res.data) {
              this.allSaleReportList = res.data.saleList;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            saleReportService
              .printSaleSummay(this.clonequeryParams)
              .then((res) => {
                if (res.data) {
                  console.log("credit=", res.data);
                  //this.saleSummaryReportList = res.data.saleSummaryList;
                  this.cashSaleList = res.data.cashSummaryList;
                  this.creditSaleList = res.data.creditSummaryList;
                  this.wholeSaleList = res.data.wholeSaleList;
                  this.creditReceiptList = res.data.creditReceiptList;
                  res.data.cashSummaryList.forEach((p) => {
                    //this.cashSaleList.push(p);
                    this.totalCashSaleAmount += p.amount;
                    this.totaltaxCashSaleAmount += p.taxAmount;
                    this.totaldiscountCashSaleAmount += p.discountAmount;
                    this.totalNetCashSaleAmount += p.netAmount;
                  });
                  res.data.creditSummaryList.forEach((p) => {
                    //this.creditSaleList.push(p);
                    this.totalCreditSaleAmount += p.amount;
                    this.totaltaxCreditSaleAmount += p.taxAmount;
                    this.totaldiscountCreditSaleAmount += p.discountAmount;
                    this.totalNetCreditSaleAmount += p.netAmount;
                  });
                  res.data.wholeSaleList.forEach((p) => {
                    //this.wholeSaleList.push(p);
                    this.totalWholeSaleAmount += p.totalAmount;
                    this.totaltaxWholeSaleAmount += p.taxAmount;
                    this.totaldiscountWholeSaleAmount += p.discountAmount;
                    this.totalNetWholeSaleAmount += p.netAmount;
                  });
                  res.data.creditReceiptList.forEach((p) => {
                    this.totalCreditReceiptNetAmount += p.netAmount;
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                var printContents = document.getElementById(divName).innerHTML;
                var reprintWindow = window.open(
                  "",
                  "MsgWindow",
                  "width=500,height=500"
                );
                reprintWindow.document.write(printContents);
                setTimeout(() => {
                  reprintWindow.print();
                  reprintWindow.close();
                }, 600);
                this.buttonLoading = false;
              });
          });
      } else {
        this.messageDialogBox = true;
        this.responseError = "Choose a date range filter within a week!";
      }
    },
  },
};
</script>
